import React from 'react';
import { CalendarDaysIcon, WavesIcon, BlocksIcon, FlowerIcon, BarChart3Icon, FileTextIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
const MODULES = [{
  number: '01',
  title: 'Ready-To-Teach Class Library',
  icon: CalendarDaysIcon,
  lead: 'Open a complete, professionally structured yoga class whenever you need one.',
  body: 'Classes organized by duration, experience level, teaching format, and student objective.',
  tags: '30, 45, 60 & 75 Minutes · Beginner to Advanced · Studio, Private & Online'
}, {
  number: '02',
  title: 'Professional Sequence Library',
  icon: WavesIcon,
  lead: 'Access structured yoga flows created for different goals, needs, and teaching environments.',
  body: 'Each sequence includes a clear objective, logical pose order, smooth transitions, modifications, and teaching guidance.',
  tags: 'Mobility · Strength · Flexibility · Balance · Recovery · Relaxation'
}, {
  number: '03',
  title: 'Class Builder System',
  icon: BlocksIcon,
  lead: 'Create a complete class in minutes without beginning with a blank page.',
  body: 'Combine ready-made warm-ups, pose blocks, transitions, breathwork, meditation, and cool-down sections to build professional sessions quickly.',
  tags: 'Warm-Ups · Flow Blocks · Breathwork · Meditation · Cool-Downs'
}, {
  number: '04',
  title: 'Pose & Teaching Library',
  icon: FlowerIcon,
  lead: 'Your professional reference for essential yoga poses and effective instruction.',
  body: 'Find alignment principles, verbal cues, common mistakes, safe modifications, contraindications, and transition suggestions in one organized system.',
  tags: 'Alignment · Cueing · Modifications · Safety · Transitions'
}, {
  number: '05',
  title: 'Student Progression Toolkit',
  icon: BarChart3Icon,
  lead: 'Give every student a clearer path forward with practical evaluation and progress resources.',
  body: 'Track attendance, goals, mobility, consistency, class notes, and development over time.',
  tags: 'Assessments · Goals · Progress Tracking · Attendance · Reviews'
}, {
  number: '06',
  title: 'Instructor Resource Vault',
  icon: FileTextIcon,
  lead: 'The professional templates and teaching documents every yoga instructor needs for consistent weekly preparation.',
  body: 'Plan classes, organize workshops, manage teaching notes, and access practical resources whenever you need them.',
  tags: 'Planning Templates · Checklists · Worksheets · Calendars · Teaching Documents'
}];
export function Modules() {
  return <section aria-labelledby="modules-title" className="w-full bg-white px-4 py-10 sm:px-6" data-id="element-130" data-mp="2vo63k8g8o4n1">
      <div className="mx-auto max-w-6xl" data-id="element-131" data-mp="2vltc94olchxb">
        <div className="text-center" data-id="element-132" data-mp="3jcpbgmvdmfel">
          <span className="font-head text-[11px] font-bold uppercase tracking-wider text-brand sm:text-xs" data-id="element-133" data-mp="3jbnn5gpcnwex">
            The Complete Teaching Collection
          </span>
          <h2 id="modules-title" className="mt-2 font-head text-2xl font-extrabold uppercase leading-tight text-charcoal sm:text-3xl" data-id="element-134" data-mp="1co6t1ai624b8">
            Inside the main box set — six complete professional modules
          </h2>
        </div>

        <div className="mt-6 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-135" data-mp="1hfok96ue0qj0">
          {MODULES.map(mod => {
          const Icon = mod.icon;
          return <article key={mod.number} className="flex flex-col rounded-2xl border border-brand/15 bg-ivory p-4 transition hover:border-brand/40" data-id="element-136" data-mp="tsgqnm6bn5wt">
                <div className="flex items-center gap-2" data-id="element-137" data-mp="13mqldaiqkgap">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand text-white" data-id="element-138" data-mp="yop32rt4wl0a">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-139" data-mp="2f2nmry7rgsot" />
                  </span>
                  <span className="font-head text-[10px] font-bold uppercase tracking-widest text-brand-dark" data-id="element-140" data-mp="2a43vdiaeeop2">
                    Module {mod.number}
                  </span>
                </div>
                <h3 className="mt-2 font-head text-base font-bold uppercase leading-tight text-charcoal sm:text-lg" data-id="element-141" data-mp="onwga4dwj4h0">
                  {mod.title}
                </h3>
                <p className="mt-1.5 text-sm leading-snug text-charcoal" data-id="element-142" data-mp="xnazqjvnies0">{mod.lead}</p>
                <p className="mt-1.5 text-sm leading-snug text-softgray" data-id="element-143" data-mp="12mnnr7y9drw6">{mod.body}</p>
                <p className="mt-3 border-t border-brand/15 pt-2 font-head text-[11px] font-semibold uppercase leading-snug tracking-wide text-brand-dark" data-id="element-144" data-mp="12ktcymgpbg5t">
                  {mod.tags}
                </p>
              </article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-145" data-mp="1gdj0wwfsiv5k">
          <CtaButton data-id="element-146" data-mp="1ldnk4u8323zh" />
          <TrustRow className="mt-3" data-id="element-147" data-mp="1le6p7acmwxw3" />
        </div>
      </div>
    </section>;
}